import { useSelector } from 'react-redux'
import { Table } from '../../../../../common/table'
import {
  changeIncomeStatementIds,
  selectIncomeStatementChildIds,
  selectIncomeStatementIds,
  selectIncomeStatementItem,
  selectIncomeStatementParentId,
  selectIncomeStatementRowData,
  selectIsLoading,
  selectTableHeader,
} from '../store/slice'
import { CustomTHead } from '../table/CustomTHead'
import { FinancialStatementsValueCell } from '../table/FinancialStatementsValueCell'
import { FirstColumnCell } from '../table/firstColumnCell/FirstColumnCell'

export const IncomeStatement = () => {
  const incomeStatementIds = useSelector(selectIncomeStatementIds)
  const isLoading = useSelector(selectIsLoading)
  const tableHeader = useSelector(selectTableHeader)

  return (
    <Table
      ids={incomeStatementIds}
      getDataFromRedux={selectIncomeStatementItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      autoHeightMax={400}
      renderTHead={() => <CustomTHead tableTitle={tableHeader} />}
      schema={tableHeader.map((item, index) => {
        const title = item.title
        const colId = `${item.colId}`

        const result = {
          title,
          colId,
        }
        if (index === 0) {
          return {
            ...result,
            render: (val, { rowId }) => {
              return (
                <FirstColumnCell
                  ids={incomeStatementIds}
                  rowId={rowId}
                  val={val}
                  selectRowData={selectIncomeStatementRowData}
                  selectChildIds={selectIncomeStatementChildIds}
                  selectParentIds={selectIncomeStatementParentId}
                  changeIds={changeIncomeStatementIds}
                  tabName="incomeStatements"
                />
              )
            },
          }
        }
        return {
          ...result,
          render: (val) => {
            return <FinancialStatementsValueCell val={val} />
          },
        }
      })}
    />
  )
}
